import { createContext } from 'react';

const ContextAppReceita = createContext();

export default ContextAppReceita;
